import { primaryPollutionDriver, PL, STAGES_ORDER, STAGE_FULL, getScoreColor } from "@/lib/reportUtils";

export const PollutionDriver = ({ paramsByStage, scoreScale = 1 }) => {
  const driver = primaryPollutionDriver(paramsByStage);
  return (
    <div data-testid="pollution-driver">
      <p className="text-[11px] text-[#617364] mb-2 italic">
        Primary pollution driver per stage — weakest of GWP, Pollution Burden, Ecosystem Impact, Water Impact.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-2">
        {STAGES_ORDER.filter((s) => driver[s]).map((s) => {
          const d = driver[s];
          const critical = d.adj < 4;
          return (
            <div key={s} className={`rounded-lg border p-2 ${critical ? "border-[#D32F2F]/30 bg-[#D32F2F]/5" : "border-[#E0E6E1] bg-white"}`}>
              <p className="text-[10px] uppercase tracking-wider font-bold text-[#617364] mb-1">{STAGE_FULL[s]}</p>
              <p className="text-[11px] font-semibold text-[#1B291D]">{critical && "⚠️ "}{PL[d.pk]}</p>
              <p className="text-[10px]" style={{ color: getScoreColor(d.adj) }}>Score: <strong>{(d.adj * scoreScale).toFixed(2)}</strong></p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
